module.exports = __webpack_public_path__ + "img/seckill_logo.19fd17e.png";